<section class="prepurchases" aria-labelledby="prepurchases-title">
  <h2 id="prepurchases-title" class="prepurchases__title">{{ title }}</h2>

  <ul class="prepurchases__list" role="list">
    @for (prepurchase of prepurchases(); track prepurchase.id) {
      <li class="prepurchase-card">
        <div class="prepurchase-card__head">
          <span class="prepurchase-card__number">{{ prepurchase.number }}</span>
          <app-badge class="prepurchase-card__state" [variant]="stateVariant(prepurchase.state.key)">
            {{ prepurchase.state.label }}
          </app-badge>
        </div>

        <p class="prepurchase-card__product">{{ prepurchase.product_name }}</p>

        <div class="prepurchase-card__meta">
          @if (formatIsoDate(prepurchase.date); as date) {
            <span class="prepurchase-card__date">{{ date }}</span>
          }
          <span class="prepurchase-card__quantity">{{ quantityLabel(prepurchase.quantity) }}</span>
        </div>

        @if (prepurchase.proof; as proof) {
          <app-badge class="prepurchase-card__proof" [variant]="proofVariant(proof.key)">{{ proof.label }}</app-badge>
        }

        <div class="prepurchase-card__foot">
          <span class="prepurchase-card__total-label">{{ totalLabel }}</span>
          <span class="prepurchase-card__total">{{ formatCrc(prepurchase.total) }}</span>
        </div>

        @if (prepurchase.note !== null) {
          <p class="prepurchase-card__note">{{ prepurchase.note }}</p>
        }
      </li>
    }
  </ul>
</section>
